import { FC } from 'react'

import { useIsTextTruncated } from '@inno-tools/react-hooks'
import { IconSizes } from '@inno-ui/icons'
import { Tooltip, TooltipPlacements } from '@inno-ui/tooltip'
import clsx from 'clsx'
import { NavLink } from 'react-router-dom'

import styles from './HeaderLink.module.scss'
import { HeaderLinkProps } from './HeaderLink.types'

export const HeaderLink: FC<HeaderLinkProps> = ({ to, icon: Icon, label }) => {
  const { isTruncated, textRef } = useIsTextTruncated()

  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        clsx(styles.headerLink, { [styles.active]: isActive })
      }
    >
      <Icon size={IconSizes.Size34} color='var(--white)' />
      <Tooltip
        disabled={!isTruncated}
        overlay={label}
        placement={TooltipPlacements.Bottom}
        zIndex={1000}
      >
        <span className={styles.label} ref={textRef}>
          {label}
        </span>
      </Tooltip>
    </NavLink>
  )
}
